import { Instant } from 'modules/graphql';

export enum ExperimentVariationInputType {
  EMAIL = 'Email',
  PUSH = 'Push',
  SMS = 'SMS',
  SEND_TIME = 'SendTime',
  WEB_PUSH = 'WebPush',
}

export enum ExperimentVariationInputArg {
  EMAIL = 'emailVariation',
  PUSH = 'pushVariation',
  SMS = 'smsVariation',
  SEND_TIME = 'sendTimeVariation',
  WEB_PUSH = 'webPushVariation',
}

export type EmailVariationInput = {
  fromName?: string;
  senderEmail?: string;
  subjectLine?: string;
  preHeader?: string;
};

export type PushVariationInput = {
  title?: string;
  message?: string;
};

export type SmsVariationInput = {
  message?: string;
  image?: string;
};

export type WebPushVariationInput = {
  title?: string;
  body?: string;
  icon?: string;
  clickAction?: string;
};

export type SendTimeVariationInput = {
  sendTimeStartTime: Instant;
};

export interface CommonVariantUpdateProps {
  experimentId: number;
  variationId: number;
  variationName?: string;
  locale: string;
}

export interface EmailVariant extends CommonVariantUpdateProps {
  variationType: ExperimentVariationInputType.EMAIL;
  [ExperimentVariationInputArg.EMAIL]: EmailVariationInput;
}

export interface PushVariant extends CommonVariantUpdateProps {
  variationType: ExperimentVariationInputType.PUSH;
  [ExperimentVariationInputArg.PUSH]: PushVariationInput;
}

export interface SMSVariant extends CommonVariantUpdateProps {
  variationType: ExperimentVariationInputType.SMS;
  [ExperimentVariationInputArg.SMS]: SmsVariationInput;
}

export interface WebPushVariant extends CommonVariantUpdateProps {
  variationType: ExperimentVariationInputType.WEB_PUSH;
  [ExperimentVariationInputArg.WEB_PUSH]: WebPushVariationInput;
}

export interface SendTimeVariant extends CommonVariantUpdateProps {
  variationType: ExperimentVariationInputType.SEND_TIME;
  [ExperimentVariationInputArg.SEND_TIME]: SendTimeVariationInput;
}

export type UpdateVariantProps =
  | EmailVariant
  | PushVariant
  | SMSVariant
  | WebPushVariant
  | SendTimeVariant;

export type UpdateVariantArgs = Omit<UpdateVariantProps, 'experimentId'>;
